import React from "react";
import { Row, K, V } from "./styles";

interface SummaryRowProps {
  label: string;
  value: React.ReactNode;
}

export default function SummaryRow({ label, value }: SummaryRowProps) {
  return (
    <Row>
      <K>{label}</K>
      <V>{value}</V>
    </Row>
  );
}
